<template>
  <div id="app" v-cloak>
    <!--判断是否是播放页的子路由，子路由不加key缓存父级页面-->
    <router-view v-if="$route.fullPath.indexOf('lesson-') == -1 || $route.fullPath.indexOf('lesson-detail') != -1" :key="$route.fullPath"/>
    <router-view v-if="$route.fullPath.indexOf('lesson-') != -1 &&  $route.fullPath.indexOf('lesson-detail') == -1"/>
    <div class="float" v-if="$route.meta.sidebar!==false">
      <div class="float-index" @click="$router.push('/index')" v-show="$route.meta.index!==true">返回首页</div>
      <div class="float-me" @click="$router.push('/me')" v-show="$route.meta.my!==true">我的慕课</div>
    </div>
    <!--<login-dialog :isOpen="isLoginDialogShow" @close="isLoginDialogShow=false"></login-dialog>-->
  </div>
</template>

<script>
import tools from "./util/tools";
import $ from "jquery"
export default {
  name: 'App',
  data(){
    return{
      isLoginDialogShow:false,
      key: geturl_j("v_key")
    }
  },
  created(){
    // this.checkNeedLogin();
    window._v = this,
    this.key = tools.getCookie("center_key");
  },
  // methods:{
  //   checkNeedLogin(){
  //     if(this.$route.meta.needLogin){
  //       if(!this.$store.state.isLogin){
  //         this.isLoginDialogShow=true;
  //       }
  //       else{
  //         this.isLoginDialogShow=false;
  //       }
  //     }
  //     else{
  //       this.isLoginDialogShow=false;
  //     }
  //   }
  // },
  // watch:{
  //   $route(){
  //     this.checkNeedLogin()
  //   }
  // }
  watch: {
    $route: {
      immediate: true,
      deep: true,
      handler(to) {
        // 微信浏览器判断
        const WECHAT_BROWSER = navigator.userAgent.toLowerCase().includes('micromessenger')

        // 解决iOS微信浏览器分享地址只能是落地页的问题，这个操作是不会刷新页面的，query参数改变也会执行
        if (WECHAT_BROWSER) {
          // eslint-disable-next-line
          // window.location.href = window.location.href
        }
      }
    },
    key(newValue, oldValue) {
      if (newValue != oldValue&&newValue!=null) {
        $.ajax({
          url: "/api/proxy/index",
          data: {
            api: "/api/proxy/logout",
            user_type: tools.getCookie("user_type"),
          },
          success: function (res) {
            if (res.status === 1) {
              location.reload();
            }
          },
        });
      }
    }
  }

}
setTimeout(() => {
  eventBus.$on('link_m', (u) => {
    console.log(u)
    _v.$router.push(u);
  });
},300)
//获取导航参数
function geturl_j(name) {
  return (
    decodeURIComponent(
      (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
        location.href
      ) || [, ""])[1].replace(/\+/g, "%20")
    ) || null
  );
}
</script>

<style>
[v-cloak]{
  display: none;
}
/*#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}*/
</style>



// WEBPACK FOOTER //
// src/App.vue